// extracted by mini-css-extract-plugin
export default {"category":"catagory_category__KAVCZ","category__container":"catagory_category__container__eNzoq"};